import { useNavigate } from 'react-router-dom';
import * as AccountApi from '../redux/api/AccountApi';
import { UserApi } from '../redux/api/UserApi';

/// Redirects to the home page when the user closes the browser tab.
const useRedirectOnClose = () => {
  const navigate = useNavigate();
  const { data: userProfile } = UserApi.useGetUserProfileQuery();
  const { data: hostConfig } = AccountApi.useGetHostConfigQuery(userProfile?.Tenant_Uid, { skip: !userProfile?.Tenant_Uid });

  const handleRedirect = (ticketId?: number) => {
    if (hostConfig?.Close_Call_Page_Action === 1) {
      navigate('/');
    } else if (ticketId) {
      navigate(`/ticket/${ticketId}`);
    }
  };

  return handleRedirect;
};

export default useRedirectOnClose;